import React, { useState, useEffect } from "react";

import { Grid, Box, Modal, Typography, Paper, IconButton, Button } from "@mui/material";

const SettingsView = () => {
  return (
    <Box sx={{ flexGrow: 1, p: 2, backgroundColor: "background.default" }}>
      <Typography variant="h1">Settings</Typography>
      {/* button to execute proc getEc2s */}
    </Box>
  );
};

export default SettingsView;
